import type { LocalDate } from '../../../utilities/local-date';

/**
 * Takes dates for year start and end, and period start and end
 * Returns period dates cropped to year
 */
export function crop(
  yearStartDate: LocalDate,
  yearEndDate: LocalDate,
  periodStartDate: LocalDate,
  periodEndDate: LocalDate,
) {
  let startDate = yearStartDate;
  if (periodStartDate.isAfter(yearStartDate)) {
    startDate = periodStartDate;
  }
  let endDate = yearEndDate;
  if (periodEndDate.isBefore(yearEndDate)) {
    endDate = periodEndDate;
  }
  return {
    startDate: startDate,
    endDate: endDate,
  };
}
